import * as React from 'react'
import { connect } from 'react-redux'

import { redirectToOffer } from 'common/actions'
import MortgageOfferList from 'embed/components/MortgageOfferList'
import { MortgageOffer } from 'embed/constants/models'
import { ratesSortedOffersSelector } from 'embed/selectors/rates'
import { OfferType, Product, RedirectType } from 'even-ts-static'
export interface Props {
  mortgageOffers: MortgageOffer[]
  dispatchRedirectToOffer: (MortgageOffer) => void
}

const MortgageOfferListContainer: React.FC<Props> = ({ dispatchRedirectToOffer, mortgageOffers }) => {
  const onMortgageOfferClick = React.useCallback(
    (offer) => {
      dispatchRedirectToOffer(offer)
    },
    [dispatchRedirectToOffer],
  )

  return <MortgageOfferList onMortgageOfferClick={onMortgageOfferClick} mortgageOffers={mortgageOffers} />
}

const mapStateToProps = (state) => ({
  mortgageOffers: ratesSortedOffersSelector(state)[Product.Mortgage]?.mortgageOffers ?? [],
})

const mapDispatchToProps = (dispatch) => ({
  dispatchRedirectToOffer: (offer: MortgageOffer) =>
    dispatch(redirectToOffer(offer, OfferType.Mortgage, RedirectType.MANUAL)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MortgageOfferListContainer)
